import Button from "@mui/material/Button";
import { ui } from "./tokens";

export function PrimaryButton({ sx, children, ...props }) {
  return (
    <Button variant="contained" sx={{ ...ui.btnPrimary, ...(sx || {}) }} {...props}>
      {children}
    </Button>
  );
}

export function OutlineButton({ sx, children, ...props }) {
  return (
    <Button variant="outlined" sx={{ ...ui.btnOutline, ...(sx || {}) }} {...props}>
      {children}
    </Button>
  );
}
